import React, { useState } from 'react';
import { Button } from '@mui/material';
import PictureAsPdf from '@mui/icons-material/PictureAsPdf';
import { Document, Page } from 'react-pdf';
//import 'react-pdf/dist/esm/Page/TextLayer.css';
//import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import '../styling/TextLayer.css';
import '../styling/AnnotationLayer.css';
import instructionsPdf from '../pdfs//dataEntryInstructions.pdf';


function PdfTool(props) {
    const { moreToolsIndex } = props;
    const [ numPages, setNumPages ] = useState(null);
    const [ pageNumber, setPageNumber ] = useState(1);
    const [ showPdf, setShowPdf ] = useState(false);
    const pdfFile = moreToolsIndex === "Data entry instructions" ? instructionsPdf : null;

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
        setPageNumber(1);
    };

    const changePage = (offset) => {
      setPageNumber(prevPageNumber => prevPageNumber + offset);
    };

    const handleClick = () => {
        setShowPdf((previous) => !previous);
    };

    return (
        <>
            <Button startIcon={<PictureAsPdf />} color="primary" variant="contained" onClick={handleClick}>
                {showPdf ? "Hide pdf" : "View data entry instructions (pdf)"}
            </Button>
            {showPdf &&
                <div style={{textAlign:"cemter"}}>
                    <Document
                        file={pdfFile}
                        onLoadSuccess={onDocumentLoadSuccess}
                    >
                        <Page pageNumber={pageNumber} />
                    </Document>
                    <>
                        <p>
                            Page {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}
                        </p>
                        <button 
                            type="button" 
                            disabled={pageNumber <= 1} 
                            onClick={()=>changePage(-1)}
                        >
                            Previous
                        </button>
                        <button
                            type="button"
                            disabled={pageNumber >= numPages}
                            onClick={()=>changePage(1)}
                        >
                            Next
                        </button>
                    </>
                </div>
            }
        </>
    );
}
export default PdfTool;